import React from "react";

export const ProjectCommittedUntil = ({ committedUntil }: { committedUntil: Date }) => (
    <p>Contract expiry: {committedUntil != null ? committedUntil.toLocaleDateString() : <span>No date</span>}</p>
);
